import React from 'react';
import { NavLink } from 'react-router-dom';
import Box from '@bit/knotchinc.web-react-components.box';
import PageHeaderContainer from '@bit/knotchinc.web-react-components.page-header-container';
import { PageBody } from '@bit/knotchinc.web-react-components.page';
import { HeaderActionButtons } from 'components/Global/Buttons';
import {
  TitleContainer,
  PrimaryTitle,
  SecondaryTitle,
  PageTabContainer,
  Subtitle,
  EntityLogo,
  PartnershipLogo,
  StyledBackTab,
  HubTitleContainer,
  HubTitle,
  HubSubTitle,
} from './styled';
import PageHeaderTabs from './PageHeaderTabs.jsx';

const PageHeader = ({
  entityLogo,
  bg,
  children,
  title,
  secondaryTitle,
  counts,
  subtitle,
  fetched = true,
  playbookLink,
  tabs,
  actionButtons,
  partnershipLogos = [],
  previousPageLink,
  previousPageLinkTitle,
  isHub = false,
}) => {
  const showCounts = counts && counts.length > 0;
  const hasSecondaryLine = showCounts || playbookLink || subtitle;
  const hasActionButtons = actionButtons && actionButtons.length > 0;
  const isPartnershipDisplay = !!partnershipLogos.length;
  let leftShift = entityLogo ? '265px' : null;
  if (isPartnershipDisplay || isHub) leftShift = '150px'; /* TODO: make this much smoother */

  return (
    <PageHeaderContainer bg={bg} show={fetched}>
      <PageBody>
        {/* Normal Entity or Hub Entity Header Logo */}
        {entityLogo ? <EntityLogo imageUrl={entityLogo} isHub={isHub} /> : null}

        {/* Partnership Entity Header Logos */}
        {isPartnershipDisplay ? partnershipLogos.map((imageUrl, idx) => <PartnershipLogo imageUrl={imageUrl} key={`partner-logo-${idx}`} />) : null}

        {/* Partnership || Hub Back Button */}
        {isPartnershipDisplay || isHub ? <StyledBackTab as={NavLink} to={previousPageLink}>Back To {`${previousPageLinkTitle}`}</StyledBackTab> : null}

        <Box left={leftShift} zIndex="2" position="absolute" bottom={(isPartnershipDisplay || isHub) ? '75px' : '36px'}>
          { isHub ? (
            <HubTitleContainer>
              <HubTitle>{title}</HubTitle>
              <HubSubTitle>{secondaryTitle}</HubSubTitle>
            </HubTitleContainer>
          ) : (
            <TitleContainer>
              <PrimaryTitle>{title}</PrimaryTitle>
              <SecondaryTitle>{secondaryTitle}</SecondaryTitle>
            </TitleContainer>
          )}
          {hasSecondaryLine && (
            <Box mt="20px" minHeight="20px">
              {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </Box>
          )}
          {hasActionButtons && <HeaderActionButtons actionButtons={actionButtons} />}
        </Box>
        <PageTabContainer backTab>{tabs ? <PageHeaderTabs tabs={tabs} /> : null}</PageTabContainer>
        {children}
      </PageBody>
    </PageHeaderContainer>
  );
};

export default PageHeader;
